import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_CREATE_KB_CLIENT_ID: ClientId = client('jsm-create-kb');

export const JSM_CREATE_KB_STAGING_AREA_CLIENT_ID: ClientId = client('jsm-create-kb-staging-area');

export const JSM_KB_CARD_CLIENT_ID: ClientId = client('jsm-create-kb-card');
